module.exports = "<span class=\"react-placeholder <%- additionalClasses %>\"></span>";